export const USER_TYPE = {
  FOUNDER: 1,
  ANGEL_INVESTOR: 2,
  VC_INVESTOR: 3,
  ACCELERATOR_INVESTOR: 4,
  CO_FOUNDER: 5,
};

export const USER_MEMBER = [
  { key: '1', value: '1' },
  { key: '2', value: '2' },
  { key: '3', value: '3' },
  { key: '4', value: '4' },
  { key: '5', value: '5' },
  { key: '6', value: '6' },
];

export const USER_PLAN = [
  { key: 'MONTHLY_PLAN', value: 'Monthly Plan' },
  { key: 'YEALY_PLAN', value: 'Yearly Plan' }
]

export const USER_REPORT_TYPE = [
  { key: 1, value: 'Founder' },
  { key: 2, value: 'Angel' },
  { key: 3, value: 'VC' },
  { key: 4, value: 'Accelerator' },
]

export const USER_STATUS = [
  { key: 'SUSPENDED', value: 'Suspended' },
  { key: 'IGNORED', value: 'Ignored' },
]

export const USER_EDIT_STATUS = [
  { key: 'SUSPENDED', value: 'Suspended' },
  { key: 'IGNORED', value: 'Ignored' },
  { key: 'OPEN', value: 'Open' }
]

export const USER_PAYMENT_TYPE = [
  { key: "2", value: 'Angel' },
  { key: "3", value: 'VC' },
  { key: "4", value: 'Accelerator' },
]

export const PAYMENT_PLAN = [
  { key: 'MONTHLY', value: 'Monthly Plan' },
  { key: 'YEARLY', value: 'Yearly Plan' }
]

export const PAYMENT_STATUS = [
  { key: 'completed', value: 'Success' },
  { key: 'failed', value: 'Failed' },
  { key: 'refunded', value: 'Refund' },
]

export const ADMIN_ACTION = [
  { key: 'CHANGED', value: 'Changed' },
  { key: 'SUSPENDED', value: 'Suspended' },
  { key: 'RESTORED', value: 'Restored' },
  { key: 'REFUND', value: 'Refunded' },
  { key: 'CREATED', value: 'Created' },
]